// removed by extract-text-webpack-plugin
module.exports = {"WPContent":"Z4b-QgyxUj2AWadAZi60W"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Pages/styles.css
// module id = 707
// module chunks = 0